const paymentStatus = {
    SUCCESS: "SUCCESS",
    PENDING: "PENDING",
    EXPIRED: "EXPIRED",
    FAILED: "FAILED"
}

export { paymentStatus }